<template>
    <InventoryCard
        :inventory="inventory"
        :statuses="statuses"
        :warehouses="warehouses"
        :selected-status="selectedStatus"
        :selected-warehouse="selectedWarehouse"
        @update:selected-status="selectedStatus = $event"
        @edit="editInventory"
        @delete="deleteInventory"
    />
    <ProductItemsTable
        v-if="inventory && selectedWarehouse"
        :inventory="inventory"
        :warehouse="selectedWarehouse"
        :exit-declaration-status-uuids="exitDeclarationStatusUuids"
        :arrival-declaration-status-uuids="arrivalDeclarationStatusUuids"
    />
</template>

<script>
import InventoryCard from './cards/InventoryCard.vue'
import ProductItemsTable from './cards/InventoryProductItemsTableCard.vue'
import { httpClient } from '../../../../services/HttpClient'
import MessageNotificator from '../../../../services/MessageNotificator.js'

export default {
    name: 'EditInventoryPage',
    components: {
        InventoryCard,
        ProductItemsTable
    },
    data() {
        return {
            inventory: null,
            statuses: [],
            warehouses: [],
            selectedStatus: null,
            selectedWarehouse: null,
            exitDeclarationStatusUuids: [],
            arrivalDeclarationStatusUuids: []
        }
    },
    methods: {
        async fetchInventory() {
            await httpClient.get(`/management/inventories/${this.$route.params.inventoryUuid}`).then(response => {
                this.inventory = response.data.data;
            })
        },
        async fetchStatuses() {
            await httpClient.get('/management/inventory-statuses', { limit: 0 }).then(response => {
                this.statuses = response.data.data
            })
        },
        async fetchWarehouses() {
            await httpClient.get('/management/warehouses').then(response => {
                this.warehouses = response.data.data
            })
        },
        async fetchExitDeclarationStatusUuids() {
            await httpClient.get('/management/exit-declaration-statuses', {
                limit: 0
            }).then((response) => {
                this.exitDeclarationStatusUuids = response.data.data.filter(status => status.type === 'done').map(status => status.uuid)
            })
        },
        async fetchArrivalDeclarationStatuses() {
            await httpClient.get('/management/arrival-declaration-statuses', {
                limit: 0
            }).then((response) => {
                this.arrivalDeclarationStatusUuids = response.data.data.filter(status => status.type === 'done').map(status => status.uuid)
            })
        },
        async editInventory() {
            await httpClient.put(`/management/inventories/${this.inventory.uuid}/update-status`, {
                status_id: this.selectedStatus.id
            }).then(response => {
                this.inventory.status = response.data.data.status;

                new MessageNotificator().success(this.$t('alerts.success'));
            })
        },
        deleteInventory() {
            new MessageNotificator().confirm(this.$t('alerts.confirm_delete', {
                value: this.$t('labels.inventory')
            }), async () => {
                await httpClient.delete(`/management/inventories/${this.inventory.uuid}`, {
                    only_validation: false
                }).then(() => {
                    this.$router.push({ name: 'IndexInventoriesPage' })
                })
            })
        }
    },
    async mounted() {
        await this.fetchInventory();
        await this.fetchStatuses();
        await this.fetchWarehouses();
        await this.fetchExitDeclarationStatusUuids();
        await this.fetchArrivalDeclarationStatuses();

        this.selectedStatus = this.statuses.find(status => status.id === this.inventory.status.id);
        this.selectedWarehouse = this.warehouses.find(warehouse => warehouse.id === this.inventory.warehouse_id);
    }
}
</script>
